/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateMyInvitedOrganizationMutationRequest,
  UpdateMyInvitedOrganizationMutationResponse,
} from "../types/UpdateMyInvitedOrganization.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateMyInvitedOrganizationMutationKey = () =>
  [{ url: "/v1/user-onboarding/me/invited-organization" }] as const

export type UpdateMyInvitedOrganizationMutationKey = ReturnType<
  typeof updateMyInvitedOrganizationMutationKey
>

/**
 * @description Supplier portal users only. Persists verified company details for the organization linked to the user's onboarding state.
 * @summary Update current user invited organization during onboarding
 * {@link /v1/user-onboarding/me/invited-organization}
 */
export async function updateMyInvitedOrganization(
  data: UpdateMyInvitedOrganizationMutationRequest,
  config: Partial<RequestConfig<UpdateMyInvitedOrganizationMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateMyInvitedOrganizationMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateMyInvitedOrganizationMutationRequest
  >({
    method: "PUT",
    url: `/v1/user-onboarding/me/invited-organization`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateMyInvitedOrganizationMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateMyInvitedOrganizationMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateMyInvitedOrganizationMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateMyInvitedOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMyInvitedOrganizationMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return updateMyInvitedOrganization(data, config)
    },
  })
}

/**
 * @description Supplier portal users only. Persists verified company details for the organization linked to the user's onboarding state.
 * @summary Update current user invited organization during onboarding
 * {@link /v1/user-onboarding/me/invited-organization}
 */
export function useUpdateMyInvitedOrganization<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateMyInvitedOrganizationMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: UpdateMyInvitedOrganizationMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<UpdateMyInvitedOrganizationMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateMyInvitedOrganizationMutationKey()

  const baseOptions = updateMyInvitedOrganizationMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateMyInvitedOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMyInvitedOrganizationMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateMyInvitedOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMyInvitedOrganizationMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateMyInvitedOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMyInvitedOrganizationMutationRequest },
    TContext
  >
}
